export const getEducationData = (t) => [
  {
    id: "1",
    title: t('educationData.ainChock.title'),
    date: t('educationData.ainChock.date'),
    description: t('educationData.ainChock.description'),
  },
  {
    id: "2",
    title: t('educationData.youcode.title'),
    date: t('educationData.youcode.date'),
    description: t('educationData.youcode.description'),
  },
  {
    id: "3",
    title: t('educationData.istia.title'),
    date: t('educationData.istia.date'),
    description: t('educationData.istia.description'),
  },
  {
    id: "4",
    title: t('educationData.safi.title'),
    date: t('educationData.safi.date'),
    description: t('educationData.safi.description'),
  },
  {
    id: "5",
    title: t('educationData.lycee.title'),
    date: t('educationData.lycee.date'),
    description: t('educationData.lycee.description'),
  },
];
